import { Screen, StackScreenProps } from '@rahtab/stack-navigator';
import { Card, CardCaption, CardContainer, Colors, getRadius, getSpacing, Text, TextView } from '@rahtab/ui';
import ErrorCard from 'components/ErrorCard';
import LabeledText from 'components/LabeledText';
import type { RootStackType } from 'components/Router';
import useCheckRequestId, { RequestStatusCode } from 'hooks/useCheckRequestId';
import React from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import LiveHenIcon from '../components/LiveHenIcon';
import { withSeparator } from '../tools/string';

type LoadInquiryProps = StackScreenProps<RootStackType, 'LoadInquiry'>;

const LoadInquiry: React.FC<LoadInquiryProps> = ({ route }) => {
  const { RequestId = '' } = route.params || {};
  const { loading: checkingRequestId, data: checkRequest } = useCheckRequestId({ RequestId }, { skip: !RequestId });
  const isApprovableOrExists = !!RequestId && checkRequest?.resultCode !== RequestStatusCode.Invalid;
  const isApprovable = checkRequest?.resultCode === RequestStatusCode.Approvable;

  const loading = checkingRequestId;

  return (
    <Screen
      title={RequestId ? 'نتیجه استعلام شناسه سفارش' : 'ثبت اطلاعات بار ورودی بدون شناسه'}
      loading={loading}
      data={{ checkRequest }}
      renderControls={
        RequestId
          ? ({ checkRequest }) => {
              return (
                <TextView
                  marginBottom={0}
                  borderColor="default"
                  valueColor={checkRequest?.result ? 'primary' : 'secondary'}
                  title="شناسه سفارش استعلام شده"
                  value={RequestId}
                />
              );
            }
          : undefined
      }
      renderMain={({ checkRequest }) => {
        return (
          <ScrollView keyboardShouldPersistTaps="handled">
            {!!RequestId && !isApprovable && !checkRequest?.result && (
              <ErrorCard title={checkRequest?.error!} message={checkRequest?.comment!} />
            )}
            {isApprovableOrExists && (
              <Card style={styles.card}>
                <CardCaption>
                  <Text variant="cardTitle" margin="none" color="primary" style={styles.captionText}>
                    مشخصات سفارش / مرسوله استعلام شده
                  </Text>
                </CardCaption>
                <CardContainer>
                  <LiveHenIcon style={styles.liveHenIcon} />
                  <LabeledText label="تخصیص دهنده">{checkRequest?.assignerName}</LabeledText>
                  <LabeledText label="واحد مرغداری">{checkRequest?.supplierName}</LabeledText>
                  <LabeledText label="مقدار وزنی سفارش / مرسوله">
                    {withSeparator(checkRequest!.reqAmount)} {checkRequest?.reqMeasure}
                  </LabeledText>
                  <LabeledText label="تعداد قطعات مرغ زنده ورودی">
                    {withSeparator(checkRequest!.templateCount)} قطعه
                  </LabeledText>
                  <LabeledText label="تاریخ تحویل">{checkRequest?.deliveryDate}</LabeledText>
                  <LabeledText label="کشتارگاه مقصد" margin="none">
                    {checkRequest?.reqSupplierName}
                  </LabeledText>
                </CardContainer>
              </Card>
            )}
          </ScrollView>
        );
      }}
    />
  );
};

export default LoadInquiry;

const styles = StyleSheet.create({
  card: {
    margin: getSpacing(),
  },
  cardContainer: {
    borderRadius: getRadius(),
    backgroundColor: Colors.background,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: getSpacing(),
    height: getSpacing('row'),
    justifyContent: 'space-between',
    marginBottom: getSpacing(),
  },
  title: {
    flex: 1,
    marginRight: getSpacing(0.5),
  },
  captionText: {
    textAlign: 'center',
    // flex: 1,
  },
  rowView: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  textView: {
    borderColor: Colors.midGray,
    marginStart: getSpacing(),
  },
  justifiedText: {
    textAlign: 'justify',
  },
  cardIcon: {
    // marginRight: getSpacing(0.6),
    marginTop: getSpacing(),
  },
  liveHenIcon: {
    alignSelf: 'center',
    marginBottom: getSpacing(),
  },
});
